import * as React from 'react';
import { FadeInText } from 'source/app/presentation/Shared/Animation/FadeInArray';
import Hyperlink from 'source/app/presentation/Shared/Link/Hyperlink';
import Data from 'source/app/services/Data';
import { IsProduction } from 'source/app/services/External/Environment/Environment';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import { ShareState } from '../../../services/UI/State/ShareState';
import { StyleClass } from '../../Shared/Styles/CSS';

export function MasteryTitle() {
	const [ isOK, setIsOK ] = React.useState<boolean>(true);

	ShareState(ESharedFunction.MasteryTitle_isOK, isOK, setIsOK);

	return (
		<Hyperlink
			whenClicked={async () => {
				await MotwLogicServer.CacheClearAsync();
				Data.Load.AllAsync();
			}}
		>
			<FadeInText
				text="Mastery"
				tooltip="click to refresh data"
				withClass={StyleClass(`masteryTitle_${isOK}`, {
					color: isOK ? (IsProduction() ? `white` : `yellowgreen`) : `red`,
					textDecoration: isOK ? `initial` : `line-through`,
					opacity: isOK ? 1 : 0.8
				})}
			/>
		</Hyperlink>
	);
}
